import { separator } from 'src/filters/baseFilter';
import {
  isShopLiveWhite, isLiveSupportProductClick, isLiveSupportInitateCheckout, isLiveSupportCompletePayment,
} from 'src/const/whiteList';
import { isBOE } from 'src/const/boe';
import store from 'src/store/';

/**
 * shop 相关的配置
 */
import {
  OptimizeGoal,
  ExternalAction,
} from 'src/const/state/target';
import ProductItem from 'src/components/ad/ad-form/ad-form-product-item';
import ProductDetail from 'src/components/ad/ad-form/ad-form-product-detail';

/**
 * shop 的场景
 */

export const Scenario = {
  ShortVideo: 304,
  Live: 305,
};

export const ScenarioList = [
  {
    value: Scenario.ShortVideo,
    label: 'module_adgroup_scenario_video_shopping',
    subLabel: 'module_adgroup_scenario_video_shopping_hint',
    icon: 'scenario-short-video',
    disabled: false,
  },
  {
    value: Scenario.Live,
    label: 'module_adgroup_scenario_live_shopping',
    subLabel: 'module_adgroup_scenario_live_shopping_hint',
    icon: 'scenario-live',
    disabled: () => !isShopLiveWhite() && !store.state.shop.hasMagellanShop,
  },
];

/**
 * Shop 的类型
 */
export const ShopType = {
  ecommShop: 1, // 1p 闭环
  tt4bShop: 2, // 3p 半闭环
};

// 3P店铺是否已绑定TT
export const StoreBindingTTStatus = {
  binded: 1, // 已绑定
  unbinded: 2, // 未绑定
};

// 当前用户在3P店铺的角色
export const UserRoleOfStore = {
  admin: 1, // 管理员
  advertise: 2, // 广告
};

/*
  shop校验结果
*/
export const shopStateMap = {
  available: 0,
  unavailable: -1,
  notbindTTAdmin: -2, // 3p store未绑定TT & admin权限
  notbindTTNotAdmin: -3, // 3p store未绑定TT & 非admin权限
};
export const shopWarningTipsMap = {
  [shopStateMap.available]: {
    creativeBannerText: '',
  },
  [shopStateMap.unavailable]: {
    creativeBannerText: {
      copy: 'module_shop_creative_copy_dialog_shopauthority_hint',
      edit: 'module_shop_creative_edit_dialog_shopauthority_hint',
      create: 'module_shop_creative_edit_dialog_shopauthority_hint',
    },
  },
  [shopStateMap.notbindTTAdmin]: {
    creativeBannerText: 'module_creative_shop_admin_tt_banding_hint',
  },
  [shopStateMap.notbindTTNotAdmin]: {
    creativeBannerText: 'module_creative_shop_adsrole_tt_banding_hint',
  },
};

/**
 * 商品的库存状态
 */
export const ProductAvailability = {
  InOrder: 1, // 有库存
  AvailableForOrder: 2, // 可供订购
  Preorder: 3, // 预定
  OutOfStock: 4, // 缺货
  Discontinued: 5, // 停产
};


/**
 * 商品是否在TT橱窗中 目前只支持3P
 */
export const ProductStoreFrontStatus = {
  InStoreFront: 7, // 有库存
  NotInStoreFront: 8, // 可供订购
};

const ProductStoreFrontStatusMap = {
  [ProductStoreFrontStatus.InStoreFront]: {
    value: ProductStoreFrontStatus.InStoreFront,
    key: 'module_ad_spu_in_storefront',
  },
  [ProductStoreFrontStatus.NotInStoreFront]: {
    value: ProductStoreFrontStatus.NotInStoreFront,
    key: 'module_ad_spu_not_in_storefront',
  },
};

/**
 * 获取 SPU 商品表格的列
 *
 * @param {*} vm 当前组件实例
 * @returns 展示的表格
 */
export const getSpuTableColumns = (vm, config = {}) => {
  const { $createElement } = vm;
  const {
    isEcommShop,
    handleSelectSpu,
    isMultiSelectionType,
    isRowSelectable,
    inStorefrontThRenderer,
  } = config;

  return [
    {
      key: 'sku_id',
      type: 'expand',
      component: ProductDetail,
      hidden: isEcommShop, // 1P 不支持查看 SKU
    },
    {
      type: 'selection',
      width: 44,
      className: 'product-select-tbl-selection',
      selectable: isRowSelectable,
      hidden: !isMultiSelectionType, // 非多选时隐藏
    },
    {
      title: vm.$t('module_catalog_product_column_product'),
      key: 'spu_id',
      width: isMultiSelectionType ? 356 : 400, // 单选时包含ratio和图片左边距，所以大44px
      formatter: row => $createElement(ProductItem, {
        props: {
          product: row.spu,
          disabled: row?.spu?.availability_status !== ProductAvailability.InOrder,
          selectable: !isMultiSelectionType, // 多选时隐藏radio
          idPrefix: 'SPU ID: ',
          props: {
            id: 'spu_id',
          },
        },
        on: {
          select: handleSelectSpu,
        },
      }),
    },
    {
      title: vm.$t('module_catalog_product_column_price'),
      key: 'price',
      width: 150,
      align: 'right',
      formatter: (row) => {
        const { spu: { price } = {} } = row;
        // 如果区间是相等的只展示一个
        const [min = '', max = ''] = (price?.price_range || '').split('-');
        const range = min === max ? separator(min, '0,0') : `${separator(min, '0,0')}-${separator(max, '0,0')}`;
        return `${range} ${price?.price_unit}`;
      },
    },
    {
      title: vm.$t('module_catalog_product_column_category'),
      key: 'category',
      formatter: row => row.spu?.category?.name,
    },
    {
      // 是否在橱窗中 当前仅支持3P
      key: 'storefront_status',
      align: 'left',
      width: 250,
      hidden: isEcommShop,
      renderString: inStorefrontThRenderer,
      formatter: row => vm.$t(ProductStoreFrontStatusMap[row.spu?.storefront_status]?.key),
    },
  ].filter(item => !item.hidden);
};

/**
 * 获取 SKU 表格的展示的列
 * @param {*} vm 组件实例
 * @param {*} config 组件相关的方法属性
 * @returns
 */
export const getSkuTableColumns = (vm, config = {}) => [
  {
    title: vm.$t('module_catalog_product_column_product'),
    key: 'spu_id',
    width: 448, // 356 + 44 + 48 border-box 92是左边距
    className: 'column-sku-detail',
    formatter: row => vm.$createElement(ProductItem, {
      props: {
        product: row,
        selectable: false,
        idPrefix: 'SKU ID: ',
        props: {
          id: 'sku_id',
        },
      },
    }),
  },
  {
    title: vm.$t('module_catalog_product_column_price'),
    key: 'price',
    width: 150,
    align: 'right',
    formatter: (row) => {
      const { price } = row;
      return `${separator(price?.price || '', '0,0')} ${price?.price_unit}`;
    },
  },
  {
    title: vm.$t('module_catalog_product_column_category'),
    key: 'category',
    formatter: row => row.category?.name,
  },
  {
    title: vm.$t('module_catalog_product_column_availability'),
    key: 'storefront_status',
    width: 250,
    align: 'left',
    hidden: true, // 占位对齐用，该字段sku没有;1P不支持展开，所以展开情况下必然是3P有storefront_status
  },
];

/**
 * 获取Shop短视频优化目标
 * 优化目标只支持 Click 和 Convert 2 种
 * 为了给用户展示的更加的直观，优化目标直接关联浅层事件进行展示
 * 1. Click
 * 2. Convert
 *  - Initiate Checkout(Order)
 *  - Complete Payment(Purchase)
 *  - Offline Event(Offsite Event)
 * @param {Number} shopType 选择的 shop 类型，1P or 3P
 * @example
 * {
 *   label: 名称
 *   tip: 提示
 *   value: 优化目标
 *   externalAction: 直接对应的浅层事件
 *   enableShopTypes: 支持的 shop 类型
 * }
 */
export const getShopVideoOptimizeGoal = (shopType) => {
  const { ecommShop, tt4bShop } = ShopType;
  const allOptimizeGoal = [
    { // Click
      label: 'adgroup_optimize_click',
      tip: 'adgroup_optimize_click_info',
      icon: 'optimize-goal-click',
      value: OptimizeGoal.click,
      externalAction: 0,
      enableShopTypes: [ecommShop, tt4bShop],
      type: 'click',
    },
    { // Order
      label: 'module_adgroup_optimize_conversion_order',
      tip: 'module_adgroup_optimize_conversion_order_hint',
      icon: 'optimize-goal-order',
      value: OptimizeGoal.convert,
      externalAction: ExternalAction.initiateOrder,
      enableShopTypes: [ecommShop, tt4bShop],
      type: 'initiateCheckout',
    },
    { // Purchase
      label: 'module_adgroup_optimize_conversion_purchase',
      tip: 'module_adgroup_optimize_conversion_purchase_hint',
      icon: 'optimize-goal-purchase',
      value: OptimizeGoal.convert,
      externalAction: ExternalAction.shopping,
      enableShopTypes: [ecommShop],
      type: 'completePayment',
    },
    { // Offsite Event
      label: 'module_adgroup_optimize_conversion_offsite_event',
      tip: 'module_adgroup_optimize_conversion_offsite_event_hint',
      icon: 'optimize-goal-offsite-event',
      value: OptimizeGoal.convert,
      externalAction: 0, // 需要通过 pixel 去选择
      enableShopTypes: [tt4bShop],
      type: 'offsiteEvent',
    },
  ];
  return allOptimizeGoal.filter(({ enableShopTypes }) => enableShopTypes.includes(shopType));
};

/**
 * 获取Shop直播间优化目标
 * 优化目标只支持 Click 和 MT_LIVE_ROOM 2 种
 * @example
 * {
 *   label: 名称
 *   tip: 提示
 *   value: 优化目标
 *   externalAction: 直接对应的浅层事件
 * }
 */
export const getShopLiveOptimizeGoal = (shopType) => {
  const { tt4bShop } = ShopType;
  const isNottt4bShop = shopType !== tt4bShop;
  // complete payment优化目标在3p shop下不展示，不选shop或者选1p shop都展示
  const isLiveAdSupportCompletePayment = isLiveSupportCompletePayment() && isNottt4bShop;
  return [
    { // Click
      label: 'adgroup_optimize_click',
      tip: 'adgroup_optimize_click_info',
      icon: 'optimize-goal-click',
      value: OptimizeGoal.click,
      externalAction: 0,
      type: 'click',
    },
    { // liveStayTime
      label: 'module_ad_active_stay_time',
      tip: 'module_ad_active_stay_time_hint',
      icon: 'optimize-goal-stay-time',
      value: OptimizeGoal.liveStayTime,
      externalAction: ExternalAction.liveStayTime,
      type: 'liveStayTime',
    },
    ...isLiveSupportProductClick() ? // product link通过白名单控制
      [{ // product click in live
        label: 'module_adgroup_optimize_conversion_product_link',
        tip: 'module_adgroup_optimize_conversion_product_link_hint',
        icon: 'optimize-goal-product-link',
        value: OptimizeGoal.productClickInLive,
        externalAction: ExternalAction.liveClickProduct,
        type: 'productClickInLive',
      }] : [],
    ...isLiveSupportInitateCheckout() ? // live的initate通过白名单控制
      [{ // Order
        label: 'module_adgroup_optimize_conversion_order',
        tip: 'module_adgroup_optimize_conversion_order_hint',
        icon: 'optimize-goal-order',
        value: OptimizeGoal.convert,
        externalAction: ExternalAction.initiateOrder,
        type: 'initiateCheckout',
      }] : [],
    ...isLiveAdSupportCompletePayment ?
      [{
        label: 'module_adgroup_optimize_conversion_purchase',
        tip: 'module_adgroup_optimize_conversion_purchase_hint',
        icon: 'optimize-goal-purchase',
        value: OptimizeGoal.convert,
        externalAction: ExternalAction.shopping,
        type: 'completePayment',
      }] : [],
  ];
};
// 获取默认的优化目标
export const getDefaultOptimizeGoal = (shopType, optimizeGoalOptions = []) => {
  const { tt4bShop } = ShopType;
  const isNottt4bShop = shopType !== tt4bShop;
  const [firstOptimizeGoal] = optimizeGoalOptions;
  // 3p店铺默认选external event
  const tt4bShopDefaultOptimizeGoal = optimizeGoalOptions.find(og => og?.value === OptimizeGoal.convert && !og.externalAction);
  if (isNottt4bShop) return firstOptimizeGoal;

  return tt4bShopDefaultOptimizeGoal || firstOptimizeGoal;
};

// videoShopping的商品类型
export const PRODUCT_SELECTION_TYPE = {
  SINGLE: 1, // 单商品
  MULTIPLE: 2, // 多商品
};

export const productSelectionTypeOptions = [
  {
    value: PRODUCT_SELECTION_TYPE.SINGLE,
    label: 'module_ad_single_product',
    icon: 'single-product',
    disabled: false,
  },
  {
    value: PRODUCT_SELECTION_TYPE.MULTIPLE,
    label: 'module_ad_multiple_products',
    icon: 'multi-product',
    disabled: false,
  },
];

export const MULTI_PRD_LIMIT = {
  MIN: 6,
  MAX: 50,
};

export const StoreManagerDomain = isBOE ? '//boei18n-ads.byteoversea.net/i18n/stores' : '//ads.tiktok.com/i18n/stores';

// storeManager店铺设置页（可绑定TT）
export const getStoreManagerSettingPage = storeId => `${StoreManagerDomain}/${storeId}/settings`;
